import type { ModalProps } from '@ksyos/design-system';
import { Alert, Button, Modal } from '@ksyos/design-system';
import { Fragment } from 'react';
import { getSelectedLanguage } from '@frontend/translate';

interface IRequestEmploymentTaxesDetailsExportModalProps {
    declarationYear: string;
    isOpen: ModalProps['isOpen'];
    onCancel: ModalProps['onClose'];
    onClose: ModalProps['onClose'];
    onRequest: ModalProps['onCloseComplete'];
}

export function RequestEmploymentTaxesDetailsExportModal(
    props: Readonly<IRequestEmploymentTaxesDetailsExportModalProps>
) {
    const language = getSelectedLanguage();

    return (
        <Modal
            closeOnEsc={true}
            closeOnOverlayClick={true}
            isOpen={props.isOpen}
            onClose={props.onClose}
            size="large"
        >
            <Modal.Header
                sx={{ padding: '0.5rem 1rem' }}
            >{`${language.finance.employmentTaxesDetailsExport.requestNewExportModal.header} ${props.declarationYear}`}</Modal.Header>
            <Modal.Body>
                <Alert
                    appearance="warning"
                    hasIcon={true}
                >
                    {language.finance.employmentTaxesDetailsExport.requestNewExportModal.alert}
                </Alert>
                {language.finance.employmentTaxesDetailsExport.requestNewExportModal.body.split('\n').map((line, i) => (
                    <Fragment key={i}>
                        {line}
                        <br />
                    </Fragment>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={props.onCancel}
                    variant="outline"
                >
                    {language.common.cancel}
                </Button>
                <Button
                    onClick={props.onRequest}
                    variant="solid"
                >
                    {language.export.export}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
